import RouterUtils from '../../../../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import MachineState from '../../../../../shared/model/MachineState';

export class MachineUpdateRequest {

    // MachineContractorSave {
    //   id: number
    //   contractor_id: number
    //   document_schema_id: number
    // }

    _id; // number
    _brand; // string
    _model; // string
    _companyId; // number
    _description; // string
    _contractors; // MachineContractorSave[]
    _licencePlate; // string
    _machineTypeId; // number
    _machineStateId; // number

    constructor(values, machine) {
        this._id = machine.id();
        this._brand = values.brand;
        this._model = values.model;
        this._companyId = machine.companyId();
        this._description = values.description;
        this._contractors = this._parseContractorSchemas(values, machine);
        this._licencePlate = values.licensePlate;
        this._machineTypeId = undefined; // TODO(PAVASALEVO-582): comentarios
        this._machineStateId = values.state ? MachineState.ACTIVE : MachineState.INACTIVE;
    }

    url() {
        return RouterUtils.generateRoute(ApiEndpoints.MACHINE_ID, { id: this._id });
    }

    body() {
        return {
            id: this._id,
            name: this._licencePlate,
            brand: this._brand,
            model: this._model,
            notes: this._description,
            company_id: this._companyId,
            contractors: this._contractors,
            machine_type_id: this._machineTypeId,
            machine_state_id: this._machineStateId,
        };
    }

    _parseContractorSchemas(values, machine) {
        const nextSchemas = {};

        machine
            .documentation()
            .schemas()
            .forEach((s) => {
                nextSchemas[s.contractorId()] = {
                    contractor_id: s.contractorId(),
                    document_schema_id: s.documentSchemaId(),
                };
            });

        values
            .contractorSchemas
            .forEach((s) => {
                if ( nextSchemas[s.contractorId] ) {
                    if ( s.schema.length !== 0 ) {
                        nextSchemas[s.contractorId].document_schema_id = s.schema[0].value;
                    } else {
                        nextSchemas[s.contractorId] = null;
                    }
                } else {
                    if (s.schema.length !== 0) {
                        nextSchemas[s.contractorId] = {
                            contractor_id: s.contractorId,
                            document_schema_id: s.schema[0].value,
                        };
                    }
                }
            });

        return Object
            .values(nextSchemas)
            .filter(nextSchema => nextSchema !== null)
            .map((nextSchema) => ( {
                contractor_id: nextSchema.contractor_id,
                document_schema_id: nextSchema.document_schema_id !== -1
                    ? nextSchema.document_schema_id
                    : null,
            } ));
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/machine/form/update/machine-update/MachineUpdateRequest.js